import Vue from 'vue';
import Vuex from 'vuex';
import { state } from './state';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import plugins from './plugins';
import { LoadingModule } from '@/store/loading';

Vue.use(Vuex);

const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins,
    modules: {
        loading: LoadingModule,
    },
});

export default store;
